module.exports = __webpack_public_path__ + "static/young-leader-photo-marissa_chemotti-233d49782121c596ccc92ec35475260d.jpg";